import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    if (!match) { navigate("/", { replace: true }); return; }
    const session_id = match[1];
    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id });
        setUser(r.data);
        window.history.replaceState(null, "", "/");
        if (r.data.role === "admin" || r.data.role === "personale") navigate("/admin", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Accesso Google fallito");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-600 font-medium">Accesso Google in corso...</div>
    </div>
  );
}
